import styled from 'styled-components/macro'

const SearchResultSelectedFilters = styled.div`
  margin-top: 10px;
  span > span {
    background-color: #a6a6a6;
    color: #0f0f0f;
    i {
      display: none;
    }
  }
`
export default SearchResultSelectedFilters
